import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_login');

register('wm-login', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmLogin    ${getAttrMarkup(attrs)} eventsource.bind="Actions.loginAction">`;
        },
        post: () => `</${tagName}>`,
        provide: () => {
        const provider = new Map();
        provider.set('isLogin', true);
        return provider;
      }

    };
});
export default () => {};
